// @flow
import dayjs from 'dayjs';

export const DateUtils = (() => {
  // Date format - 27/01/2026 05:16:39
  const parseDateWithPeriod = (dateString) => {
    if (dateString === undefined || dateString === null || dateString === '') {
      return 'NA';
    }

    // Support API ISO datetime (e.g. 2025-12-03T00:00:00) and other valid date inputs.
    const normalizedDateString =
      typeof dateString === 'string' && dateString.includes('T')
        ? dayjs(dateString).isValid()
          ? dayjs(dateString).format('DD/MM/YYYY HH:mm:ss')
          : null
        : dateString;

    if (!normalizedDateString || typeof normalizedDateString !== 'string') {
      return 'NA';
    }

    const [date, time] = normalizedDateString.split(' ');
    if (!date || !time) {
      const parsed = dayjs(normalizedDateString);
      if (!parsed.isValid()) {
        return 'NA';
      }
      const fallbackString = parsed.format('DD/MM/YYYY HH:mm:ss');
      const [fallbackDate, fallbackTime] = fallbackString.split(' ');
      if (!fallbackDate || !fallbackTime) return 'NA';
      const [fbHours, fbMinutes, fbSeconds] = fallbackTime.split(':');
      if (!fbHours || !fbMinutes || !fbSeconds) return 'NA';
      const fbPeriodMarker = parsePeriodMarker(fbHours);
      return `${fallbackDate} ${sanitizeTime(fbHours, fbMinutes, fbSeconds)} ${fbPeriodMarker}`;
    }

    const [hours, minutes, seconds] = time.split(':');
    if (!hours || !minutes || !seconds) {
      return 'NA';
    }
    const periodMarker = parsePeriodMarker(hours);

    return `${date} ${sanitizeTime(hours, minutes, seconds)} ${periodMarker}`;
  };

  const sanitizeTime = (hours, minutes, seconds) => {
    const sanitizedHours = hours.replace(/^0+/, '');
    return `${sanitizedHours}:${minutes}:${seconds}`;
  };

  const parsePeriodMarker = (hourString) => {
    let periodMarker;
    if (parseInt(hourString) < 12) {
      periodMarker = 'am';
    } else {
      periodMarker = 'pm';
    }

    return periodMarker;
  };

  return {
    parseDateWithPeriod,
  };
})();
